import h from 'hyperscript';

import type { DatatableCellRenderedEventDetail } from 'cadenza/ui/base-table/base-table';
import { addIconBehindCellContent } from 'cadenza/result-table/result-table-utils';
import { on } from 'cadenza/utils/event-util';
import { DATATABLE_CELL_RENDERED } from 'cadenza/ui/base-table/base-table-event-types';
import { ResultTablePlugin } from 'cadenza/result-table/result-table-plugin';
import type { Teardown } from 'cadenza/utils/teardown';
import { tearDown } from 'cadenza/utils/teardown';
import { dataTypeIcon } from 'cadenza/workbook/attribute-element/data-type-icon';

const COMPONENT_NAME = 'd-lob-datatype-icon-result-table-plugin';

/**
 * Replaces removes text content of lob attribute cells (dimensions) and shows an icon instead.
 */
export class LobDatatypeIconResultTablePlugin extends ResultTablePlugin {

  /** Events registered per datatable lifetime */
  #resultTableEventKeys: Teardown[] = [];

  override init () {
    this.#resultTableEventKeys.push(
      on<CustomEvent<DatatableCellRenderedEventDetail>>(
        this.table,
        DATATABLE_CELL_RENDERED,
        e => this.#onDatatableCellRendered(e)));
  }

  disconnectedCallback () {
    this.#unregisterResultTableEventsAndStopObserving();
  }

  #unregisterResultTableEventsAndStopObserving () {
    tearDown(this.#resultTableEventKeys);
    this.#resultTableEventKeys.length = 0;
  }

  #onDatatableCellRendered ({ detail: { td, columnData } }: CustomEvent<DatatableCellRenderedEventDetail>) {
    const lobMediaType = columnData?.lobMediaType;

    if (!lobMediaType) {
      return; // Only for lob cells
    }

    const typeIcon = h('.cell-data-type-icon', dataTypeIcon(lobMediaType));

    addIconBehindCellContent(td, typeIcon, true);
  }

}

customElements.define(COMPONENT_NAME, LobDatatypeIconResultTablePlugin);
